import {IPersistenceStore} from "./ipersistence.store";
import {Scilearn} from "../../constants";
import {Observer} from "rxjs";
import {Observable} from "rxjs";
import {Injectable} from "@angular/core";
import {SessionStoragePersistenceStore} from "./session.storage.persistence.store";

/**
 * PersistenceService persists & returns values from durable storage
 */
@Injectable()
export class PersistenceService {

    constructor(private store:SessionStoragePersistenceStore) {

    }

    public getItem(name:string):Observable<string> {

        let observer:Observer<string>;
        let observable = Observable.create(o => {
            observer = o;
            this.store.getForKey(success, failure, name, name, Scilearn.KEYCHAIN_ACCESS_GROUP);
        });

        let success = function success(value) {
            observer.next(value);
            observer.complete();
        };
        let failure = function failure() {
            observer.next(null);  // key does not have a value
            observer.complete();
        };

        return observable;
    }

    public setItem(name:string, value:string):Observable<boolean> {

        let observer:Observer<boolean>;
        let observable = Observable.create(o => {
            observer = o;
            console.log("setting " + name + " to value: " + value);
            this.store.setForKey(success, failure, name, name, Scilearn.KEYCHAIN_ACCESS_GROUP, value);

        });

        let success = function success() {
/*            this.store.getForKey(function (result) {
                console.log("read value: " + result);
            }, null, name, name, Scilearn.KEYCHAIN_ACCESS_GROUP);*/
            observer.next(true);
            observer.complete();
        };
        let failure = function failure() {
            observer.next(false);
            observer.complete();
        };

        return observable;
    }


    public removeItem(name:string):Observable<boolean> {

        let observer:Observer<boolean>;
        let observable = new Observable<boolean>(o => {
            observer = o;
            this.store.removeForKey(success, failure, name, name, Scilearn.KEYCHAIN_ACCESS_GROUP);
        });

        var success = function success() {
            observer.next(true);
            observer.complete();
        };
        var failure = function failure() {
            observer.next(false);  // key does not have a value
            observer.complete();
        };

        return observable;
    }


    public setOrRemoveItem(persist:boolean, name:string, value:string):Observable<boolean> {
        if (persist) {
            return this.setItem(name, value);
        } else {
            return this.removeItem(name);
        }
    }

}
